'use client';

import { createContext, useContext } from 'react';
import type { MicroFrontendRegistryValue } from '@hen-site/lib/microFrontendRegistry/parseMicroFrontendRegistry';

const EMPTY_REGISTRY: MicroFrontendRegistryValue = { slots: {} };

const MicroFrontendRegistryContext =
  createContext<MicroFrontendRegistryValue>(EMPTY_REGISTRY);

export function MicroFrontendRegistryProvider({
  value,
  children,
}: {
  value: MicroFrontendRegistryValue;
  children: React.ReactNode;
}): React.ReactElement {
  return (
    <MicroFrontendRegistryContext.Provider value={value}>
      {children}
    </MicroFrontendRegistryContext.Provider>
  );
}

export function useMicroFrontendRegistry(): MicroFrontendRegistryValue {
  return useContext(MicroFrontendRegistryContext);
}
